import React from 'react';

import { useI18n } from '@change-corgi/core/react/i18n';

import { StyleWrapper } from '../../../../../components/StyleWrapper';
import {
	CardCvcElementWrapper,
	CardExpiryElementWrapper,
	CardNumberElementWrapper,
} from '../../../../components/StripeElementWrappers';
import type { SplitFormProps } from '../../types';

export function SplitForm(props: SplitFormProps): React.JSX.Element {
	const { translate } = useI18n();

	const {
		onCardNumberFieldFocus,
		onCardExpiryFieldFocus,
		onCardCVCFieldFocus,
		validationErrors,
		validateStripeElementOnChange: onChange,
	} = props;

	return (
		<div className="flex flex-col gap-3">
			<div data-qa="credit-card-number">
				<StyleWrapper
					label={translate('corgi.payments.stripe_elements.card_number')}
					errorMessage={validationErrors.card_number ? translate(validationErrors.card_number) : undefined}
					onFocus={onCardNumberFieldFocus}
				>
					<CardNumberElementWrapper onChange={onChange} />
				</StyleWrapper>
			</div>

			<div className="flex w-full gap-3">
				<div className="flex-1" data-qa="credit-card-expiry">
					<StyleWrapper
						label={translate('corgi.co.promote.expiration_label')}
						errorMessage={validationErrors.card_expiration ? translate(validationErrors.card_expiration) : undefined}
						onFocus={onCardExpiryFieldFocus}
					>
						<CardExpiryElementWrapper onChange={onChange} />
					</StyleWrapper>
				</div>
				<div className="flex-1" data-qa="credit-card-cvc">
					<StyleWrapper
						label={translate('corgi.payments.stripe_elements.cvc')}
						errorMessage={validationErrors.card_cvc ? translate(validationErrors.card_cvc) : undefined}
						onFocus={onCardCVCFieldFocus}
					>
						<CardCvcElementWrapper onChange={onChange} />
					</StyleWrapper>
				</div>
			</div>
		</div>
	);
}
